import { render, staticRenderFns } from "./_ip.vue?vue&type=template&id=59b9897e&lang=pug&"
import script from "./_ip.vue?vue&type=script&lang=js&"
export * from "./_ip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports